import CargoOfficerListingFilter, {
  CargoOfficerListingEmailFilter,
  CargoOfficerListingFirstNameFilter,
  CargoOfficerListingLastNameFilter,
  CargoOfficerListingActivityStatusFilter,
  CargoOfficerListingUsernameFilter,
  CargoOfficerListingCargoCompanyFilter,
} from "./types/cargo-officer-listing-filter";
import CargoOfficerListingFilterType from "./types/cargo-officer-listing-filter-type";
import CargoOfficerListingSortKey from "./types/cargo-officer-listing-sort-key";
import UserCargoOfficerListParams from "../../../../../common/services/user/cargo-officer/list/user-cargo-officer-list-params";
import UserOrder from "../../../../../common/types/user-order";

const createOrder = (
  sortKey: CargoOfficerListingSortKey | null,
): UserOrder | undefined => {
  const definition: Record<CargoOfficerListingSortKey, UserOrder> = {
    [CargoOfficerListingSortKey.FIRST_NAME_ASC]: UserOrder.FIRST_NAME_ASC,
    [CargoOfficerListingSortKey.FIRST_NAME_DESC]: UserOrder.FIRST_NAME_DESC,
    [CargoOfficerListingSortKey.LAST_NAME_ASC]: UserOrder.LAST_NAME_ASC,
    [CargoOfficerListingSortKey.LAST_NAME_DESC]: UserOrder.LAST_NAME_DESC,
    [CargoOfficerListingSortKey.USERNAME_ASC]: UserOrder.USERNAME_ASC,
    [CargoOfficerListingSortKey.USERNAME_DESC]: UserOrder.USERNAME_DESC,
  };

  return sortKey ? definition[sortKey] : undefined;
};

const create = (
  page: number,
  pageSize: number,
  filters: CargoOfficerListingFilter[],
  sortKey: CargoOfficerListingSortKey | null,
): UserCargoOfficerListParams => {
  const statusFilter = filters.find(
    (filter) => filter.type === CargoOfficerListingFilterType.ACTIVITY_STATUS,
  )?.value as CargoOfficerListingActivityStatusFilter["value"] | undefined;

  return {
    page,
    pageSize,
    firstName: filters.find(
      (filter) => filter.type === CargoOfficerListingFilterType.FIRST_NAME,
    )?.value as CargoOfficerListingFirstNameFilter["value"] | undefined,
    lastName: filters.find(
      (filter) => filter.type === CargoOfficerListingFilterType.LAST_NAME,
    )?.value as CargoOfficerListingLastNameFilter["value"] | undefined,
    email: filters.find(
      (filter) => filter.type === CargoOfficerListingFilterType.EMAIL,
    )?.value as CargoOfficerListingEmailFilter["value"] | undefined,
    username: filters.find(
      (filter) => filter.type === CargoOfficerListingFilterType.USERNAME,
    )?.value as CargoOfficerListingUsernameFilter["value"] | undefined,
    cargoCompany: filters.find(
      (filter) => filter.type === CargoOfficerListingFilterType.CARGO_COMPANY,
    )?.value as CargoOfficerListingCargoCompanyFilter["value"] | undefined,
    status: statusFilter,
    order: createOrder(sortKey),
  };
};

const cargoOfficerListingLoadParamsFactory = {
  create,
};

export default cargoOfficerListingLoadParamsFactory;
